<template>
    <v-snackbar
        bottom
        right
        multi-line
        :color="color"
        v-model="visible"
        data-testid="snackbar"
        :timeout="color === 'error' ? 10000 : 6000"
    >
        <span v-html="message" />
        <v-btn
            data-testid="snackbar-close-btn"
            class="snackbar-close-btn"
            dark
            text
            @click.prevent="visible = false"
        >
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  computed: {
    color() {
      let color = "";
      if (this.$store.state.snackbar.type === "error") {
        color = "error";
      } else if (this.$store.state.snackbar.type === "success") {
        color = "success";
      } else if (this.$store.state.snackbar.type === "alert") {
        color = "warning";
      };
      return color;
    },

    message() {
      return this.$store.state.snackbar.message;
    },

    visible: {
      get: function() {
        return this.$store.state.snackbar.visible;
      },
      set: function(newVal) {
        this.$store.commit("setVisible", newVal);
      }
    }
  }
};
</script>
